export default "__VITE_ASSET__xn9SQH1j__"